import useGetTeamsForProjectOrReleaseGroup from '../../../../hooks/api/teams/useGetTeamsForProjectOrReleaseGroup';

import ProjectAffiliation from './ProjectAffiliation';

type ProjectAffiliationContainerProps = {
  /** The project locator (if we are on a project summary page). */
  projectLocator?: string;
  /** The project group id (if we are on a release group summary page). */
  releaseGroupId?: number;
  /** Labels to show with each affiliation. */
  labels?: string[];
};

/**
 * This is the "container component" (ie: holds all state/business) for the ProjectAffiliation component.
 */
const ProjectAffiliationContainer = ({
  projectLocator,
  releaseGroupId,
  labels,
}: ProjectAffiliationContainerProps) => {
  const { data: teamsAndCounts, isLoading } = useGetTeamsForProjectOrReleaseGroup(projectLocator, releaseGroupId);

  return (
    <ProjectAffiliation
      projectLocator={projectLocator}
      labels={labels || []}
      isFetching={isLoading}
      isProject={!!projectLocator}
      teams={teamsAndCounts?.teams || []}
      totalCount={teamsAndCounts?.totalCount || 0}
    />
  );
};

export default ProjectAffiliationContainer;
